<template lang="html">
  <transition-group :class="{dark: darkmode}" class="projects" tag="div" name="move">
    <transition-group tag="div" key="project" :class="{maximizedProject:visible}">
    <AveAddProjectMax
      :darkmode = "darkmode"
      v-if="visible"
      @close="visible = false"
      @emitInputs="addProject"
      ref="projectScreen"
      key="projectMax"
    />
    <AveAddProject
      :darkmode = "darkmode"
      v-if="!visible"
      @open="scrollToView"
      key="projectMin"
    />
  </transition-group>
    <AveProjects
      :darkmode = "darkmode"
      v-for="(project) in projects"
      :key="project.id"
      :projectTitle="project.title"
      :id="project.id"
      :initialtodo="initialtodo"
      @expand="handleExpand"
      :expanded="expandedId === project.id"
      @emitDelete="deleteProject"
      @emitEdit="editProject"
    />
  </transition-group>
</template>

<script>
import AveAddProject from '@/components/AveAddProject.vue';
import AveProjects from '@/components/AveProjects.vue';
import AveAddProjectMax from '@/components/AveAddProjectMax.vue';

import db from '@/db';

export default {
  name: 'Components',
  components: {
    AveAddProject,
    AveAddProjectMax,
    AveProjects,
  },
  data() {
    return {
      projects: [], // title: Titel, createdAt, timetracked, time,
      visible: false,
      expandedId: -1,
      initialtodo: {},
    };
  },
  async created() {
    try {
      this.visible = true;
      // fetch todos from database
      this.projects = await db.projects.reverse().toArray();
    } catch (err) {
      console.warn(`Error fetching todos: ${err.message}`);
    }
  },
  mounted() {
    this.visible = false;
  },
  methods: {
    deleteProject(data) {
      // starting a toasty before delting
      this.$store.commit('addToasty', {
        // action prop to delete Project
        action: async () => {
          // // console.log(`Deleted with data: ${data}`);
          try {
            // deleting todo in database with current id
            await db.projects.delete(data);
            for (let i = 0; i < this.projects.length; i += 1) {
              if (this.projects[i].id === data) {
                this.projects.splice(i, 1);
              }
            }
          } catch (err) {
            console.warn(`Error deleting project: ${err.message}`);
          }
          this.$store.commit('closeToasty', this.$store.state.toasties[this.$store.state.toasties.length - 1].id);
        },
        labelClose: 'Oh no, don\'t delete it!',
        labelConfirm: 'It\'s alright!',
        iconClose: 'wrong',
        iconConfirm: 'done',
        text: 'You seem to have deleted this project. Would your like to rebuild it?',
      });
    },

    async editProject(changes) {
      // // console.log(`Changes: ${changes}`);
      const currentProject = changes.id;
      let index = 0;
      for (let i = 0; i < this.projects.length; i += 1) {
        if (this.projects[i].id === currentProject) {
          index = i;
        }
      }
      // // console.log(`Current: ${changes.title}`);
      try {
        // updating properties in database
        await db.projects.update(currentProject, { title: changes.title });
        // editing properties in view
        // // console.log(`old: ${this.projects[index].title}`);
        this.projects[index].title = changes.title;
      } catch (err) {
        console.warn(`Error editing projects: ${err.message}`);
      }
    },

    handleExpand(id) {
      if (id === this.expandedId) {
        this.expandedId = -1;
      } else {
        this.expandedId = id;
      }
    },
    expand(data) {
      // // console.log(data);
      this.expandedId = data;
      // this.expanded = true;
    },
    parseInputToMilli(input) {
      // console.log(input);
      // Eingabe 10:20 Alles vor : ist Stunde alles danach ist Minute
      // Eingabe 10 20 Alles vor "" ist Stunde alles danach ist Minute
      // Eingabe 10 Alles ist Stunde
      if (input.includes(':')) {
        // console.log('Eingabe im Format 10:20');
        const str = input.split(':');
        // console.log(str);
        return Number.parseInt(str[0], 10) * 3600000 + Number.parseInt(str[1], 10) * 60000;
      } if (input.includes(' ')) {
        // console.log('Eingabe im Format 10 20');
        const str = input.split(' ');
        // console.log(str);
        return Number.parseInt(str[0], 10) * 3600000 + Number.parseInt(str[1], 10) * 60000;
      }
      // console.log('Eingabe im Format 10');
      const str = input;
      // console.log(str);
      return Number.parseInt(str, 10) * 3600000;
    },

    async addProject(data) {
      this.visible = true;
      const project = {
        title: data.title,
        creationDate: data.createdAt,
        time: this.parseInputToMilli(data.time),
        donetime: 0,
      };
      this.initialtodo = {
        title: data.todoTitle,
        creationDate: data.createdAt,
        time: this.parseInputToMilli(data.time),
        label: data.todoLabel,
        done: 0,
        donetime: 0,
      };

      // Add Project to databse and local Array
      try {
        // pushing new todo into database
        const newIdProject = await db.projects.add(project);
        this.initialtodo.projectId = newIdProject;
        // const newIdTodo = await db.todos.add(todo);
        await db.todos.add(this.initialtodo);
        // pushing new todo with new id into view array
        this.projects.unshift({ id: newIdProject, ...project });
        // this.todos.unshift({ id: newIdTodo, ...todo });
      } catch (err) {
        console.warn(`Error pushing new todo into db: ${err.message}`);
      }
      this.visible = !this.visible;
    },

    scrollToView() {
      this.visible = true;

      // // console.log(this.$refs.projectScreen.$el);
      this.$nextTick(() => {
        this.$refs.projectScreen.$el.scrollIntoView();
      });
    },
  },
  props: {
    darkmode: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'
@require '../assets/styles/base.styl'


.projects
  position: relative;
  width $innerBoxWidth
  margin auto
  margin-top $marginBottom
  margin-bottom 9%
  display grid
  grid-template-columns repeat(2, 1fr)
  column-gap 1.5vw
  row-gap 1.5vw
  grid-auto-flow: row dense;

  &.dark
    transform translateY(100px)

.move-move,
.v-move
  transition: transform 400ms ease
  z-index: -1

.v-enter-active,
.v-leave-active
  transition: opacity 200ms ease

  &.v-enter,
  &.v-leave-to
    opacity: 0
.v-leave-active
  position: absolute;

.maximizedProject
  grid-column-end: span 2

</style>
